<section id="pricing" aria-labelledby="pricing-heading" class="border-t border-cp-line">
  <div [class]="inner + ' ' + pad">
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12">
      <h2 id="pricing-heading" [class]="h2">Strategic Pricing for Strategic Advisors</h2>
      <p [class]="lead + ' max-w-[40ch] lg:pt-2'">Wherever you're going, there's a plan to get you there.</p>
    </div>

    @if (errorMessage()) {
      <p role="alert" class="mt-10 flex items-start gap-2.5 text-[15px] text-cp-danger">
        <ng-icon name="phosphorWarningCircle" size="18" class="mt-0.5 shrink-0" aria-hidden="true" />
        {{ errorMessage() }}
      </p>
    }

    <!-- Hairline columns, no cards. The lead plan is set apart by its primary pill and trial note. -->
    <div class="mt-16 grid grid-cols-1 border-t border-cp-line lg:grid-cols-3">
      @for (plan of v3Plans; track plan.name; let i = $index) {
        <article [class]="'flex flex-col py-10 lg:px-8 ' + (i === 0 ? 'lg:pl-0 ' : 'max-lg:border-t border-cp-line lg:border-l ') + (i === v3Plans.length - 1 ? 'lg:pr-0' : '')">
          <div class="flex items-center gap-3">
            <h3 [class]="h3">{{ plan.name }}</h3>
            @if (plan.comingSoon) {
              <span class="rounded-full bg-cp-fill px-2.5 py-0.5 text-[12px] text-cp-muted">Coming Soon</span>
            }
          </div>
          <p [class]="body + ' mt-2 min-h-[3.2em] max-w-[34ch]'">{{ plan.description }}</p>

          <p class="mt-8 flex items-baseline gap-1">
            <span [class]="'font-[510] tracking-[-0.022em] text-cp-ink ' + (plan.period ? 'text-[3rem] leading-none tabular-nums' : 'text-[2rem] leading-[1.5]')">{{ plan.price }}</span>
            @if (plan.period) {
              <span class="text-[15px] text-cp-subtle">{{ plan.period }}</span>
            }
          </p>
          <p class="mt-2 h-5 text-[13px] text-cp-accent-fg">{{ plan.badge || '' }}</p>

          <div class="mt-6">
            @if (plan === leadPlan) {
              <button type="button" (click)="handlePlanAction(plan)" [disabled]="isLoading()" [class]="btnPrimary + ' w-full'">
                @if (isLoading()) {
                  <ng-icon name="phosphorCircleNotch" size="16" class="animate-spin motion-reduce:animate-none" aria-hidden="true" />
                  Loading...
                } @else {
                  {{ plan.cta }}
                }
              </button>
            } @else {
              <button type="button" (click)="handlePlanAction(plan)" [disabled]="plan.comingSoon || isLoading()" [class]="btnSecondary + ' w-full'">{{ plan.cta }}</button>
            }
          </div>

          <ul class="mt-8 space-y-3">
            @for (feature of plan.features; track feature) {
              <li class="flex gap-2.5 text-[14px] leading-snug text-cp-muted">
                <ng-icon name="phosphorCheck" size="15" class="mt-0.5 shrink-0 text-cp-subtle" aria-hidden="true" />
                <span>{{ feature }}</span>
              </li>
            }
          </ul>
          @if (plan.note) {
            <p class="mt-6 text-[12px] leading-relaxed text-cp-subtle">{{ plan.note }}</p>
          }
        </article>
      }
    </div>

    <p class="mt-6 border-t border-cp-line pt-8">
      <a href="/documents/pricing" target="_blank" rel="noopener noreferrer" [class]="textLink">
        View Platform Pricing
        <ng-icon name="phosphorArrowUpRight" size="15" aria-hidden="true" />
        <span class="sr-only">(opens in a new tab)</span>
      </a>
    </p>
  </div>
</section>
